import { render, staticRenderFns } from "./SoundWaveRight.vue?vue&type=template&id=d9bd7ec4"
import script from "./SoundWaveRight.vue?vue&type=script&lang=js"
export * from "./SoundWaveRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports